import React, { useEffect, useRef } from 'react'

import { Button, Dropdown, Menu } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'

import { getJob } from '../../../utils/api/export'
import { generalErrorHandler, isObject } from '../../../utils'
import { selectUser } from '../../../reducers/UserReducer'

export const SUPPORTED_FORMATS = [
  { label: '.csv', value: 'csv' },
  { label: '.xlsx', value: 'xlsx' }
]
const INTERVAL_TIME = 1500

const ExportButton = ({ extraParameters, apiExport, apiDownload }) => {
  const user = useSelector(selectUser
  )

  const jobInterval = useRef(null)

  useEffect(() => {
    return () => {
      if (jobInterval.current) {
        clearInterval(jobInterval)
      }
    }
  }, [])

  const handleExport = (e) => {
    const value = e.item.props.data
    const body = isObject(extraParameters) ? { ...extraParameters, format: value } : { format: value }

    apiExport(body, user).then(json => {
      if (json && json.status !== 'error') {
        jobInterval.current = setInterval(() => {
          getJob(json.job, user).then(json => {
            if (json && json.data) {
              clearInterval(jobInterval.current)

              const fileName = json.data.result
              try {
                apiDownload(fileName, user)
              } catch (err) {
                generalErrorHandler(err)
                clearInterval(jobInterval.current)
              }
            } else if (!json || json.status === 'error') {
              clearInterval(jobInterval.current)
            }
          })
        }, INTERVAL_TIME)
      }
    })
  }

  return (
    <Dropdown
      overlay={
        <Menu onClick={handleExport}>
          {SUPPORTED_FORMATS.map((f, index) => {
            return <Menu.Item key={index} data={f.value}>{f.label}</Menu.Item>
          })}
        </Menu>
      }
      trigger={['click']}
    >
      <Button>
        <FontAwesomeIcon icon='file-export' />
      </Button>
    </Dropdown>
  )
}

export default ExportButton
